const prefix = '@@seat-selection-integration';

const ASSIGN_TICKET_TYPE_TO_MODEL = `${prefix}/ASSIGN_TICKET_TYPE_TO_MODEL`;
const UNASSIGN_TICKET_TYPE_FROM_MODEL = `${prefix}/UNASSIGN_TICKET_TYPE_FROM_MODEL`;
const CREATE_TICKET_TYPE = `${prefix}/CREATE_TICKET_TYPE`;
const DELETE_TICKET_TYPE = `${prefix}/DELETE_TICKET_TYPE`;
const CALCULATE_TICKET_TYPE_CACHE_KEY = `${prefix}/CALCULATE_TICKET_TYPE_CACHE_KEY`;

export {
    ASSIGN_TICKET_TYPE_TO_MODEL,
    UNASSIGN_TICKET_TYPE_FROM_MODEL,
    CREATE_TICKET_TYPE,
    DELETE_TICKET_TYPE,
    CALCULATE_TICKET_TYPE_CACHE_KEY,
};
